// Pure filename/label helpers extracted from init.ts.
// No DOM access — fully unit-testable.
// Consumer: buildTooltipHTML in init.ts.
/** Extract the file extension (including leading dot, lower-cased) from a filename. */
export function fileExtFromFilename(filename) {
    return filename.toLowerCase().replace(/^.*(\.[^.]+)$/, '$1');
}
/** Map a file extension to the human-readable unit label used in progress tooltips. */
export function unitLabelForExt(ext) {
    if (ext === '.pptx')
        return 'Slide';
    if (ext === '.xlsx')
        return 'Tab';
    return 'Page';
}
